// mobile product page gallery
function moveMobileSticky() {
    const mobileSticky = document.getElementById("mobile-sticky");
    const productMain = document.querySelector(".product__main");
    const productOuter = document.querySelector(".product__outer");
    if (window.innerWidth < 750) {
        if (mobileSticky && productMain && productOuter) {
          // Move #mobile-sticky to be a sibling of .product__main
          productOuter.insertBefore(mobileSticky, productMain.nextSibling);
          requestAnimationFrame(() => {
                mobileSticky.style.opacity = "1";
            });
        }
    }
}
window.addEventListener("resize", moveMobileSticky);
window.addEventListener("DOMContentLoaded", moveMobileSticky);